import { render, staticRenderFns } from "./PaymentProgramInfo.vue?vue&type=template&id=56a0b1c2&"
import script from "./PaymentProgramInfo.vue?vue&type=script&lang=js&"
export * from "./PaymentProgramInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports